import { render, staticRenderFns } from "./HKbusinessKYC.vue?vue&type=template&id=53804280&scoped=true"
import script from "./HKbusinessKYC.vue?vue&type=script&lang=js"
export * from "./HKbusinessKYC.vue?vue&type=script&lang=js"
import style0 from "./HKbusinessKYC.vue?vue&type=style&index=0&id=53804280&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53804280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53804280')) {
      api.createRecord('53804280', component.options)
    } else {
      api.reload('53804280', component.options)
    }
    module.hot.accept("./HKbusinessKYC.vue?vue&type=template&id=53804280&scoped=true", function () {
      api.rerender('53804280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/businessKYC/components/HKbusinessKYC.vue"
export default component.exports